import mIconManifest from './assets/icons-manifest.json'

const iconConfig = { ...mIconManifest }

export const generateBase64Source = (icon, color = 'default') => ({
    uri: `data:image/png;base64,${iconConfig[`${icon}_${color}`] || iconConfig[`${icon}`]}`,
})
